module.exports = __webpack_public_path__ + "img/round.4f95724e.png";